import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import { fmtDate, money, type AdminProposal, type AuditItem, type PageMeta } from '../lib/types'
import { StatusBadge } from '../components/StatusBadge'

export function ProposalsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['proposals'],
    queryFn: () => api<AdminProposal[]>('/admin/proposals'),
  })
  return (
    <div>
      <h1 className="page-title">Отклики</h1>
      <p className="page-sub">Предложения исполнителей</p>
      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th>Проект</th>
              <th>Исполнитель</th>
              <th>Цена</th>
              <th>Статус</th>
              <th>Дата</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && <tr><td colSpan={5}>Загрузка…</td></tr>}
            {data?.map((p) => (
              <tr key={p.id}>
                <td style={{ maxWidth: 260, whiteSpace: 'normal' }}>{p.order_title || p.order_id}</td>
                <td>{p.executor_name || '—'}</td>
                <td>{money(p.price, p.currency)}</td>
                <td><StatusBadge value={p.status} /></td>
                <td>{fmtDate(p.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export function ReportsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['reports'],
    queryFn: () => api<{ id: string; target_type: string; target_id: string; reason: string; status: string; created_at?: string }[]>('/admin/reports'),
  })
  return (
    <div>
      <h1 className="page-title">Жалобы</h1>
      <p className="page-sub">Модерация обращений пользователей</p>
      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th>Тип</th>
              <th>Объект</th>
              <th>Причина</th>
              <th>Статус</th>
              <th>Дата</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && <tr><td colSpan={5}>Загрузка…</td></tr>}
            {data?.map((r) => (
              <tr key={r.id}>
                <td>{r.target_type}</td>
                <td>{r.target_id}</td>
                <td style={{ whiteSpace: 'normal', maxWidth: 320 }}>{r.reason}</td>
                <td><StatusBadge value={r.status} /></td>
                <td>{fmtDate(r.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export function AuditPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['audit'],
    queryFn: () => api<{ items: AuditItem[]; meta: PageMeta }>('/admin/audit-logs?page_size=100'),
  })
  return (
    <div>
      <h1 className="page-title">Audit Log</h1>
      <p className="page-sub">Журнал действий сотрудников (только чтение)</p>
      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th>Время</th>
              <th>Админ</th>
              <th>Действие</th>
              <th>Сущность</th>
              <th>ID</th>
              <th>Meta</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && <tr><td colSpan={6}>Загрузка…</td></tr>}
            {data?.items.map((a) => (
              <tr key={a.id}>
                <td>{fmtDate(a.created_at)}</td>
                <td>{a.actor_name || '—'}</td>
                <td>{a.action}</td>
                <td>{a.entity_type || '—'}</td>
                <td>{a.entity_id || '—'}</td>
                <td style={{ whiteSpace: 'normal', maxWidth: 280 }}>{JSON.stringify(a.meta || {})}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
